<!-- <template>
    <div v-if="highlightedItems.length" class="container-services-first">
        <h2 class="main-title">{{ $t("activities") }}</h2>
        <div id="item-services-first-list" class="grid-view item-services-first-list">
            <div v-for="item in highlightedItems" :key="item.id" class="services-first-element">
                <app-highlighted-services-card :id="item.id"></app-highlighted-services-card>
            </div>
        </div>
    </div>
</template>

<script>
import HighlightedServicesCard from './HighlightedServicesCard.vue';
import { mapGetters, mapActions } from 'vuex'

export default {
    data() {
        return {
            htmlContent: ""
        }
    },
    computed: {
        ...mapGetters(["highlightedServicesItems", "getChildrenByParentId"]),
        highlightedItems() {
            let items = [];
            let parent = this.highlightedServicesItems[0];
            if (!parent) return [];
            items = this.getChildrenByParentId(parent.id);
            return items;
        }
    },
    components: {
        appHighlightedServicesCard: HighlightedServicesCard
    },
    methods: {
        ...mapActions(["fetchContentById"]),
        loadData() {
            if (this.id) {
                this.fetchContentById(this.id).then((contentResposnse) => {
                    if (contentResposnse && contentResposnse.content) {
                        this.htmlContent = contentResposnse.content;
                    }
                });
            }
        },
    },
    mounted() {
        this.loadData();

    },
    watch: {
        // content() {
        //     this.loadData();
        // }
        highlightedItems(newItems) {
            if (Array.isArray(newItems) && newItems.length) {
                this.loadData(); 
            }
        }
    },
}
</script>

<style scoped>
.main-title {
    color: var(--main-color);
    font-size: 30px;
    margin-bottom: 15px;
    font-weight: 600;
    /* letter-spacing: -0.025em; */
    cursor: pointer;
    padding-left: 3px;
}

.services-first {
    padding: 2% 7% 2% 7%;
    background-color: var(--light-color);
}

.services-first::after {
    padding: 2% 7% 2% 7%;
}

/* Services first carousel */
.container-services-first {
    width: 100%;
    padding: 20px 7% 0px 7%;
    display: block;
    justify-content: center;
    align-items: center;
    position: relative;
    background-color: var(--light-color);
}

.services-first-element {
    border-radius: 15px;
    background-color: var(--main-color);
    /* padding: 10px 10px; */
    min-height: 200px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.services-first-element:hover {
    transform: scale(1.02);
}

.grid-view {
    display: grid;
    gap: 20px;
    width: 100%;
    grid-template-columns: repeat(4, 1fr);
    align-items: stretch;
}

@media only screen and (max-width: 992px) {
    .grid-view {
        grid-template-columns: repeat(2, 1fr);
    }
}


@media only screen and (max-width: 700px) {
    .grid-view {
        grid-template-columns: repeat(1, 1fr);
    }

    .services-first-element {
        width: 100%;
        min-width: unset;
    }
}
</style> -->

<template>
    <div class="main-container">
        <section v-if="highlightedServicesItems.length" class="quick-access">
            <div class="section-header">
                <h2 class="title">{{ $t("activities") }}</h2>
                <p class="subtitle">{{ $t("activitiesSubtitle") }}</p>
            </div>

            <div class="quick-access-grid">
                <app-highlighted-services-card v-for="item in highlightedServicesItems" :key="item.id" :item="item" />
            </div>
        </section>
    </div>
</template>

<script>
import HighlightedServicesCard from './HighlightedServicesCard.vue'
import { mapGetters } from 'vuex'

export default {
    components: {
        appHighlightedServicesCard: HighlightedServicesCard
    },
    computed: {
        ...mapGetters(['highlightedServicesItems'])
    }
}
</script>

<style scoped>
.main-container {
    padding: 32px 7%;
}

.title {
    color: var(--main-color);
    font-size: 30px;
    font-weight: 600;
    cursor: pointer;
    margin: 0;
}

.subtitle {
    margin: 0;
    font-size: 14px;
    color: #64748b;
}

.quick-access {
    max-width: 1440px;
    margin: 0 auto;
    border-bottom: 1px solid #e8ecf0;
}

.section-header {
    display: flex;
    align-items: baseline;
    gap: 14px;
    margin-bottom: 22px;
}

.quick-access-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
}

@media (max-width: 992px) {
    .quick-access-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 600px) {
    .section-header {
        display: block;
    }

    .quick-access-grid {
        grid-template-columns: 1fr;
    }
}
</style>